/**
 * http://usejsdoc.org/
 */
import { EventEmitter } from 'events';

import Api from '../services/loads-api';

import api2 from '../services/gotnpayTerminalapi';
import api3 from '../services/reservationapi';
import api4 from '../services/terminalapi';


import jumpersStore from './jumpers-store';
import reportsStore from './report-store';
import Speech from 'speak-tts'
import swal from 'sweetalert';

class Loads extends EventEmitter {
	constructor() {
		super();
		this.prefix = 'LOADS_STORE_';
		this.dailyActivities = {};
		this.eventQueue = [];
		this.loadQueue = null;
		this.schoolWaitlist = [];
		this.loads = [];
		this.completedLoads = [];
		this.loadEvent = '';
		this.isEdit = false;
		this.displayOnly = false;
		this.scrollTimer = null;
		this.scrollTimer1 = null;
		this.speech = null;
		this.activeloadNum = '';
		this.copied = false;
		this.copyValue = {};
		this.displayLoader = false;
		this.settings = [];
		this.jumperManifestMethodSetting = 'regular';
		this.affSelfManifestSetting = "yes";
		this.coachSelfManifestSetting = "no";
		this.cutValue = null
		this.cut = false;
		this.deleteJumpId = null;
		this.altitudes = [];
		this.defaultAltitude = {};
		this.studentPackages = [];
		//config settings from backend
		this.ewaivers = true;
		this.ovSeparateCheckin = false;
		this.funJumpTypes =[];
	}

	handleCreateActiveLoad = (activeLoadsDisplay) => {
		var nonInAirLoads = activeLoadsDisplay.filter(ld => !ld.inAir);
		this.emitResults(nonInAirLoads, 'createLoad');
		this.emitResults(nonInAirLoads[nonInAirLoads.length - 1], 'createLoad_' + (nonInAirLoads.length - 1));
	}
	handleUpdateActiveLoad = (activeLoadDisplay) => {
		this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
		this.emitResults(activeLoadDisplay, 'updateLoadHeader');
		this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
	}
	handleUpdateActiveLoads = (activeLoadsDisplay) => {
		var nonInAirLoads = activeLoadsDisplay.filter(ld => !ld.inAir);

		nonInAirLoads.forEach(activeLoad => {
			this.emitResults(activeLoad, 'updateLoad_' + activeLoad.loadNum);
		})
		this.emitResults(activeLoadsDisplay, 'getExistingLoadsLoadcall');
		this.emitResults(activeLoadsDisplay, 'updateAllLoadsInStaffBoard');
	}
	setListeners = (socket) => {
		socket.on("createActiveLoad", data => {
			console.log('createActiveLoad');
			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadsDisplay = data;
			this.setActiveLoadsForDisplay(activeLoadsDisplay);
			console.log(activeLoadsDisplay);
			if (this.isEdit) {
				this.loadEvent = 'createLoad';
				this.loadQueue = activeLoadsDisplay.filter(ld => !ld.inAir);
				this.eventQueue.push({ data: activeLoadsDisplay, function: this.handleCreateActiveLoad })
			}
			else {
				this.handleCreateActiveLoad(activeLoadsDisplay);
			}
		});
		socket.on('updateActiveLoad', data => {
			console.log('updateActiveLoad');

			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
				this.eventQueue.push({ data: activeLoadDisplay, function: this.handleUpdateActiveLoad })

			}
			else {
				this.handleUpdateActiveLoad(activeLoadDisplay);
			}
		})
		socket.on('updateActiveLoads', data => {
			console.log('updateActiveLoads');

			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadsDisplay = data;
			this.updateActiveLoadsForDisplay(activeLoadsDisplay);

			if (this.isEdit) {
				this.loadQueue = activeLoadsDisplay;
				this.loadEvent = 'updateLoad2';
				this.eventQueue.push({ data: activeLoadsDisplay, function: this.handleUpdateActiveLoads })
			}
			else {
				this.handleUpdateActiveLoads(activeLoadsDisplay);
			}
		})

		socket.on('updateLoadCallTimers', data => {
			console.log('updateInAir');

			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadsDisplay = data;
			this.updateActiveLoadsForDisplay(activeLoadsDisplay);

			if (this.isEdit) {
				this.loadQueue = activeLoadsDisplay;
				this.loadEvent = 'updateLoad2';
			}
			else {
				this.emitResults(this.loads, 'getExistingLoadsLoadcall');
			}
		})
		socket.on('updateInAir', data => {
			console.log('updateInAir');

			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadsDisplay = data;
			this.updateActiveLoadsForDisplay(activeLoadsDisplay);

			if (this.isEdit) {
				this.loadQueue = activeLoadsDisplay;
				this.loadEvent = 'updateLoad2';
			}
			else {
				var nonInAirLoads = activeLoadsDisplay.filter(ld => !ld.inAir);
				this.emitResults(nonInAirLoads, 'createLoad');

				nonInAirLoads.forEach((ld, indx) => {
					this.emitResults(ld, 'createLoad_' + (indx));
				})
				this.emitResults({}, 'createLoad_' + (nonInAirLoads.length));
				this.emitResults(activeLoadsDisplay, 'getExistingLoadsLoadcall');
				this.emitResults(activeLoadsDisplay, 'updateAllLoadsInStaffBoard');
			}
		})
		socket.on("updateCompletedLoads", data => {
			console.log('updateCompletedLoads');

			this.emitResults(data, 'updateCompletedLoads');
		})

		socket.on("updateCompletedLoad", data => {
			console.log("updateCompletedLoads 161", data)
			this.emitResults(data.load, 'updateLoad_' + data.load.loadNum);
			this.updateCompletedLoadsForDisplay([data.load]);

			//updateLoadHistory(data);
		})

		socket.on("createTandemJump", data => {
			console.log('createTandemJump');

			//console.log(data);
			// var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				}
				/*
				this.speech.speak({
						text: 'Tandem Jump Created',
				}).then(() => {
						console.log("Success !")
				}).catch(e => {
						console.error("An error occurred :", e)
				})
				*/
			}

		});
		socket.on("createCoachJump", data => {
			console.log('createCoachJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');


				}
			}
		});

		socket.on("createAffJump", data => {
			console.log('createAffJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			console.log('create aff');

			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');


				}
			}
		});

		socket.on("createFunJump", data => {
			console.log('createFunJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');


			}
		});
		socket.on("removeObserver", data => {
			console.log('removeObserver');

			// console.log('removeObserver event');
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');


			}
		});
		socket.on("addObserver", data => {
			console.log('addObserver');

			// console.log('addObserver event');
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');


			}
		});
		socket.on("addJumpers", data => {
			console.log('addJumpers');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');
			}
		});

		socket.on("removeJumper", data => {
			console.log('removeJumper');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');


			}
		});

		socket.on("approveJumper", data => {
			console.log('approveJumper');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
			}
		});

		socket.on("loadStatusUpdate", data => {
			console.log('loadStatusUpdate');

			//console.log('in closeLoad socket event');
			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				if (data.announcement !== "" && window.ENV.enableSpeak) {
					this.speech.speak({
						text: data.announcement,
					}).then(() => {
						// console.log("Success !")
					}).catch(e => {
						console.error("An error occurred :", e)
					})
				}
			}
		});

		socket.on("closeLoad", data => {
			console.log('closeLoad io event');

			//console.log('in closeLoad socket event');
			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');
			}
		});
		socket.on("openLoad", data => {
			console.log('openLoad io event');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');
			}
		});
		socket.on("reopenLoad", data => {
			console.log('reopenLoad io event');

			//alert(data.load);
			//console.log('completeLoad socket event');
			//console.log(data);
			//this.setActiveLoadsForDisplay(data.activeLoads);

			if (this.isEdit) {
				this.loadQueue = data;
				this.loadEvent = 'completeLoad';
			}
			else {
				const { loadsPerPage } = JSON.parse(localStorage.getItem('jumperDetails'))
				var load = data.load;
				this.completedLoads = this.completedLoads.filter(ld => ld.loadNum !== load.loadNum);
				this.loads.push(load);
				this.loads.sort((a, b) => a.loadNum - b.loadNum);
				data.loadTimes?.forEach((ldt, indx) => {
					this.loads[indx].timeRemaining = ldt.timeRemaining;
					this.loads[indx].isNext = ldt.isNext;
				})
				console.log(this.loads);
				var completedLoads = this.completedLoads;
				var activeLoads = this.loads;

				var nonInAirLoads = this.loads.filter(ld => !ld.inAir);
				if (completedLoads.length > 12 && localStorage.getItem("role") !== "video edit") {
					completedLoads = completedLoads.slice(-12);
				}

				if (nonInAirLoads.length % loadsPerPage === 1 || (completedLoads.length % loadsPerPage === 0 && completedLoads.length < 12)) {
					this.emitResults({ load: data.load, completedLoads:  this.completedLoads , activeLoads: this.loads }, 'completeLoad');
				}
				else {
					nonInAirLoads.forEach((ld, indx) => {
						this.emitResults(ld, 'createLoad_' + (indx));
					})

					console.log('running through completed loads');
					completedLoads.forEach((ld, indx) => {
						console.log(ld.loadNum);
						console.log(-(indx + 1));
						this.emitResults(ld, 'createLoad_' + (-(indx + 1)));
					})
					this.emitResults({}, 'createLoad_' + (-completedLoads.length - 1));

				}
				//this.emitResults(data.activeLoads, 'getExistingLoadsLoadcall');

			}
		});
		socket.on("completeLoad", data => {
			console.log('completeLoad io event');

			//alert(data.load);
			//console.log('completeLoad socket event');
			//console.log(data);
			//this.setActiveLoadsForDisplay(data.activeLoads);

			if (this.isEdit) {
				this.loadQueue = data;
				this.loadEvent = 'completeLoad';
			}
			else {
				const { loadsPerPage } = JSON.parse(localStorage.getItem('jumperDetails'))

				var load = data.load;
				var loadNum = load.loadNum;
				this.loads = this.loads.filter(ld => ld.loadNum !== loadNum);
				data.loadTimes?.forEach((ldt, indx) => {
					this.loads[indx].timeRemaining = ldt.timeRemaining;
					this.loads[indx].isNext = ldt.isNext;
				})
				var nonInAirLoads = this.loads.filter(ld => !ld.inAir);
				this.completedLoads.push(load);
				var completedLoads = this.completedLoads;
				if (completedLoads.length > 12 && localStorage.getItem("role") !== "video edit" ) {
					completedLoads = completedLoads.slice(-12);
				}

				if (nonInAirLoads.length % loadsPerPage === 0 || completedLoads.length % loadsPerPage === 1) {
					this.emitResults({ load: data.load, completedLoads: this.completedLoads, activeLoads: this.loads }, 'completeLoad');
				}
				else {
					nonInAirLoads.forEach((ld, indx) => {
						this.emitResults(ld, 'createLoad_' + (indx));
					})
					this.emitResults({}, 'createLoad_' + (nonInAirLoads.length));

					console.log('running through completed loads');
					this.emitResults(completedLoads[completedLoads.length - 1], 'createLoad_' + (-(completedLoads.length - 1)));

					completedLoads.forEach((ld, indx) => {
						console.log(ld.loadNum);
						console.log(-(indx + 1));
						this.emitResults(ld, 'createLoad_' + (-(indx + 1)));
					})
				}


				this.emitResults(this.loads, 'updateAllLoadsInStaffBoard');

				this.emitResults(this.loads, 'getExistingLoadsLoadcall');

			}
		});
		socket.on("cancelLoad", data => {
			console.log('cancelLoad');

			var loads = data;
			var activeLoadsDisplay = data;
			this.setActiveLoadsForDisplay(activeLoadsDisplay);

			//console.log(loads);
			/*
			loads.forEach((load)=>{
				activeLoadsDisplay.push(this.transformLoad(load));
			});*/
			if (this.isEdit) {
				this.loadQueue = activeLoadsDisplay;
				this.loadEvent = 'cancelLoads';
			}
			else {
				//this.emitResults(activeLoadsDisplay, 'cancelLoads');
				var nonInAirLoads = activeLoadsDisplay.filter(ld => !ld.inAir);
				this.emitResults(nonInAirLoads, 'createLoad');

				nonInAirLoads.forEach((ld, indx) => {
					this.emitResults(ld, 'createLoad_' + (indx));
				})
				this.emitResults({}, 'createLoad_' + (nonInAirLoads.length));

				this.emitResults(activeLoadsDisplay, 'getExistingLoadsLoadcall');
				this.emitResults(activeLoadsDisplay, 'updateAllLoadsInStaffBoard');
			}
		});
		socket.on("resetDay", data => {
			//console.log(data.loads);
			this.emitResults(data, 'resetDay');
		});

		socket.on("deleteTandemJump", data => {
			console.log('deleteTandemJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				}
			}
		});

		socket.on("updateTandemJump", data => {
			console.log('updateTandemJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				}
				if (data.announcement !== "" && window.ENV.enableSpeak) {
					this.speech.speak({
						text: data.announcement,
					}).then(() => {
						console.log("Success !")
					}).catch(e => {
						console.error("An error occurred :", e)
					})
				}
			}
		});

		socket.on("updateAffJump", data => {
			console.log('updateAffJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				}
				if (data.announcement !== "" && window.ENV.enableSpeak) {
					this.speech.speak({
						text: data.announcement,
					}).then(() => {
						// console.log("Success !")
					}).catch(e => {
						console.error("An error occurred :", e)
					})
				}
			}
		});

		socket.on("updateFunJump", data => {
			console.log('updateFunJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');

			}
		});
		socket.on("deleteCoachJump", data => {
			console.log('deleteCoachJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				}
			}
		});
		socket.on("updateCoachJump", data => {
			console.log('updateCoachJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				}
				if (data.announcement !== "" && window.ENV.enableSpeak) {
					this.speech.speak({
						text: data.announcement,
					}).then(() => {
						console.log("Success !")
					}).catch(e => {
						console.error("An error occurred :", e)
					})
				}
			}
		});
		socket.on("deleteAffJump", data => {
			console.log('deleteAffJump');

			//console.log(data);
			//var activeLoadDisplay = this.transformLoad(data);
			var activeLoadDisplay = data;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				if (activeLoadDisplay.loadNum === 0) {
					this.emitResults(activeLoadDisplay, 'updateSchoolWaitlist');
					this.schoolWaitlist = activeLoadDisplay;
				}
				else {
					this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
					this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
					this.emitResults(activeLoadDisplay, 'updateLoadHeader');

				}
			}
		});
		socket.on("deleteFunJump", data => {
			console.log('deleteFunJump');

			// console.log(data);
			// var activeLoadDisplay = this.transformLoad(data.load);
			var activeLoadDisplay = data.load;
			this.updateActiveLoadsForDisplay([activeLoadDisplay]);

			if (this.isEdit) {
				this.loadQueue = activeLoadDisplay;
				this.loadEvent = 'updateLoad_' + activeLoadDisplay.loadNum;
			}
			else {
				this.emitResults(activeLoadDisplay, 'updateLoad_' + activeLoadDisplay.loadNum);
				this.emitResults(activeLoadDisplay, 'updateLoadInStaffBoard');
				this.emitResults(activeLoadDisplay, 'updateLoadHeader');

			}
		});

		socket.on('updateTimers', data => {
			console.log('updateTimers');

			// console.log('in updateTimers event');
			var activeLoads = data;
			this.updateActiveLoadsForDisplay(activeLoads);

			if (this.isEdit) {
				this.loadQueue = activeLoads;
				this.loadEvent = 'updateAllLoads';
			}
			else {
				activeLoads.forEach(activeLoad => {
					if (!activeLoad.isPaused) {
						this.emitResults(activeLoad, 'updateLoad_' + activeLoad.loadNum);
					}
				})
				this.emitResults(activeLoads, 'updateAllLoadsInStaffBoard');
				this.emitResults(activeLoads, 'getExistingLoadsLoadcall');
			}
		})

		socket.on('settingsUpdate', data => {
			console.log('settingsUpdate');

			// console.log('in updateTimers event');
			//var activeLoads = data;

			if (this.isEdit) {
				this.loadQueue = data;
				this.loadEvent = 'settingsLoaded';
			}
			else {
				//alert('settings updated');
				this.settings = data;
				this.jumperManifestMethodSetting = this.settings.filter(set => set.name === "jumper manifest method")[0];
				this.affSelfManifestSetting = this.settings.filter(set => set.name === "AFF self-manifest")[0];
				this.coachSelfManifestSetting = this.settings.filter(set => set.name === "coach self-manifest")[0];
				//alert(this.jumperManifestMethodSetting.value);
				//alert(JSON.stringify(this.jumperManifestMethodSetting));
				//alert(JSON.stringify(this.settings));
				this.emitResults(this.settings, 'settingsLoaded');
			}
		})

		socket.on("tandemVideosUploaded", data => {
			console.log('tandemVideosUploaded');

			// console.log('tandemVideosUploaded');
			//alert('tandem video uploaded');
			//var activeLoads = data;
			var role = localStorage.getItem("role");
			if (role === 'video edit') {
				if (this.isEdit) {
					this.loadQueue = data;
					this.loadEvent = 'updateCompletedLoad';
				}
				else {
					//alert('settings updated');
					//alert(this.jumperManifestMethodSetting.value);
					//alert(JSON.stringify(this.jumperManifestMethodSetting));
					//alert(JSON.stringify(this.settings));
					this.emitResults(data.load, 'updateCompletedLoad');
				}
			}
		})

		socket.on("tandemMediaUploaded", data => {
			console.log('tandemMediaUploaded');

			// console.log('tandemVideosUploaded');
			//alert('tandem video uploaded');
			//var activeLoads = data;
			var role = localStorage.getItem("role");
			if (role === 'video edit') {
				if (this.isEdit) {
					this.loadQueue = data;
					this.loadEvent = 'updateCompletedLoad';
				}
				else {
					//alert('settings updated');
					//alert(this.jumperManifestMethodSetting.value);
					//alert(JSON.stringify(this.jumperManifestMethodSetting));
					//alert(JSON.stringify(this.settings));
					this.emitResults(data.load, 'updateCompletedLoad');
				}
			}
		})
	}

	updateActiveLoadsForDisplay = (loads) => {
		loads.forEach(ld => {
			var indx = this.loads.findIndex(l => l.loadNum === ld.loadNum);
			if (indx >= 0) {
				this.loads[indx] = ld;
			}
		})
	}

	updateCompletedLoadsForDisplay = (loads) => {
		loads.forEach(ld => {
			var indx = this.completedLoads.findIndex(l => l.loadNum ===ld.loadNum);
			if(indx >= 0){
				this.completedLoads[indx] = ld;
			}
		})
	}
	setActiveLoadsForDisplay = (loads) => {
		this.loads = loads;
	}
	getActiveLoadsForDisplay = () => {
		return this.loads.filter(ld => !ld.inAir);
	}
	loadAllExistingLoads = () => {
		return new Promise((resolve, reject) => {


			Api.getAllActiveLoads().then((r) => {
				if (r.status == 200) {
					var loads = r.data.activeLoads;
					var activeLoadsDisplay = r.data.activeLoads;
					var completedLoadsDisplay = r.data.completedLoads;
					this.schoolWaitlist = r.data.schoolWaitlist;
					this.loads = r.data.activeLoads;
					this.completedLoads = r.data.completedLoads;
					/*
					loads.forEach((load)=>{
						activeLoadsDisplay.push(this.transformLoad(load));
					});*/
					var nonInAirLoads = activeLoadsDisplay.filter(ld => !ld.inAir);
					this.emitResults({ activeLoads: nonInAirLoads, completedLoads: completedLoadsDisplay }, 'getExistingLoads');
					this.emitResults({ schoolWaitlist: this.schoolWaitlist }, 'getWaitlists');
					nonInAirLoads.forEach(activeLoad => {
						this.emitResults(activeLoad, 'updateLoad_' + activeLoad.loadNum);
					})
					resolve(loads);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	createTandemJump = (loadNum, jumpPostBody) => {
		return new Promise((resolve, reject) => {
			Api.createTandemJump(loadNum, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
					resolve(true);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
					resolve(false);
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	updateTandemJump = (loadNum, jumpId, jumpPostBody) => {
		//////this.emitResults(false, 'InitilizeLoader');
		this.activeloadNum = loadNum;
		return new Promise((resolve, reject) => {
			Api.updateTandemJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
				}
				////this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					////this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	cancelTandemJump = (loadNum, jumpId) => {
		this.activeloadNum = loadNum;

		return new Promise((resolve, reject) => {
			Api.cancelTandemJump(loadNum, jumpId).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	createAffJump = (loadNum, jumpPostBody) => {
		return new Promise((resolve, reject) => {
			Api.createAffJump(loadNum, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
					resolve(true);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
					resolve(false);
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	updateAffJump = (loadNum, jumpId, jumpPostBody) => {
		this.activeloadNum = loadNum;
		//////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateAffJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
				}
				////this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}
	cancelAffJump = (loadNum, jumpId) => {
		this.activeloadNum = loadNum;

		return new Promise((resolve, reject) => {
			Api.cancelAffJump(loadNum, jumpId).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	createCoachJump = (loadNum, jumpPostBody) => {
		this.activeloadNum = loadNum;

		return new Promise((resolve, reject) => {
			Api.createCoachJump(loadNum, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
					resolve(true);

				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
					resolve(false);
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	updateCoachJump = (loadNum, jumpId, jumpPostBody) => {
		this.activeloadNum = loadNum;

		////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateCoachJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
				}
				//this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	cancelCoachJump = (loadNum, jumpId) => {
		this.activeloadNum = loadNum;

		//console.log("cancel Coach jump");
		return new Promise((resolve, reject) => {
			Api.cancelCoachJump(loadNum, jumpId).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	loadStudentPackages = () => {
		return new Promise((resolve, reject) => {

			Api.loadStudentPackages().then((r) => {
				if (r.status == 200) {
					//alert(JSON.stringify(this.jumperManifestMethodSetting));
					//alert(JSON.stringify(this.settings));
					this.studentPackages = r.data;
					resolve(this.studentPackages);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}


	loadAltitudes = () => {
		return new Promise((resolve, reject) => {

			Api.loadAltitudes().then((r) => {
				if (r.status == 200) {
					//alert(JSON.stringify(this.jumperManifestMethodSetting));
					//alert(JSON.stringify(this.settings));
					this.altitudes = r.data;
					this.altitudes.sort((a, b) => b.endAltitude - a.endAltitude);
					this.defaultAltitude = this.altitudes.filter(alt => alt.isDefault)[0];
					resolve(this.altitudes);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	getStudentPackages = () => {
		return this.studentPackages;
	}
	getAltitudes = () => {
		return this.altitudes;
	}
	getDefaultAltitude = () => {
		return this.defaultAltitude;
	}
	getLowAltitude = () => {
		return this.altitudes[this.altitudes.length - 1];
	}
	getOvSeparateCheckinSetting = () => {
		return this.ovSeparateCheckin;
	}

	getEwaiversSetting = () => {
		return this.ewaivers;
	}

	loadConfig = () => {

		//alert('load manifest config');
		
		return new Promise((resolve, reject) => {
			Api.loadJumpersConfig().then((r) => {
				if (r.status == 200) {
					window.ENV= r.data.jumpersConfig;
					api2.setApi();
					api3.setApi();
					api4.setApi();
					this.emitResults({}, 'configLoaded');
				}
			})
		})
	}
	loadSettings = () => {
		return new Promise((resolve, reject) => {

			Api.loadSettings().then((r) => {
				if (r.status == 200) {
					this.settings = r.data.settings;
					this.jumperManifestMethodSetting = this.settings.filter(set => set.name === "jumper manifest method")[0];
					this.affSelfManifestSetting = this.settings.filter(set => set.name === "AFF self-manifest")[0];
					this.coachSelfManifestSetting = this.settings.filter(set => set.name === "coach self-manifest")[0];
					//alert(JSON.stringify(this.jumperManifestMethodSetting));
					//alert(JSON.stringify(this.settings));
					this.ewaivers = r.data.configSettings.ewaivers;
					this.ovSeparateCheckin = r.data.configSettings.ovSeparateCheckin;

					this.emitResults(this.settings, 'settingsLoaded');
					resolve(this.settings);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	getAffSelfManifestSetting = () => {
		return this.affSelfManifestSetting;
	}
	getCoachSelfManifestSetting = () => {
		return this.coachSelfManifestSetting;
	}

	createFunJump = (loadNum, jumpPostBody) => {
		this.activeloadNum = loadNum;

		//////this.emitResults(false, 'InitilizeLoader');

		var pending = false;

		if (this.jumperManifestMethodSetting.value === "allow pending") {
			pending = true;
		}
		jumpPostBody.pending = pending;
		return new Promise((resolve, reject) => {
			Api.createFunJump(loadNum, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data.load);
					////console.log(r.data);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					if(r.data.message){
						swal({
							title: "Warning",
							text: r.data.message,
							icon: "warning",
							dangerMode: false,
						})
					}

					var loading = true;
					this.emitResults(loading, 'loaderActivity');
					resolve(true);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
					resolve(false);
				}
				else if (r.status == 400) {

					swal({
						title: "Warning",
						text: r.data.message,
						icon: "warning",
						dangerMode: false,
					})
					resolve(false);
				}
				else if (r.status == 400) {

					swal({
						title: "Warning",
						text: r.data.message,
						icon: "warning",
						dangerMode: false,
					})
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
					resolve(false);
				}
				////this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	addJumpers = (loadNum, jumpId, jumpPostBody) => {
		this.activeloadNum = loadNum;

		//////this.emitResults(false, 'InitilizeLoader');
		var pending = false;

		if (this.jumperManifestMethodSetting.value === "allow pending") {
			pending = true;
		}
		jumpPostBody.pending = pending;
		return new Promise((resolve, reject) => {
			Api.addJumpersToFunJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data.load);
					////console.log(r.data);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
					resolve(true);
				}
				else if (r.status == 400) {
					swal({
						title: "Warning",
						text: r.data.message,
						icon: "warning",
						dangerMode: false,
					})
					resolve(false);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					console.log(r);
					if (r.status === 202 && r.data.message.includes("load is closed or full")) {
						//alert('load is closed or full');
						this.emitResults(r.data.message, 'makeAlert');
					}
					this.emitError({ message: 'Jumpers could not be added, please contact support.' });
				}
				////this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					////this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	removeJumper = (loadNum, jumpId, jumperId) => {
		this.activeloadNum = loadNum;

		return new Promise((resolve, reject) => {
			Api.removeJumperFromFunJump(loadNum, jumpId, jumperId).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data.load);
					////console.log(r.data);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
					resolve(true);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jumpers could not be added, please contact support.' });
					resolve(false);
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	cancelFunJump = (loadNum, jumpId) => {
		this.activeloadNum = loadNum;

		return new Promise((resolve, reject) => {
			Api.cancelFunJump(loadNum, jumpId).then((r) => {
				if (r.status == 200) {
					var load = r.data;
					//var activeLoadDisplay = this.transformLoad(r.data);
					////console.log(activeLoadDisplay);
					//this.emitResults(activeLoadDisplay,'updateLoad');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');
					resolve(true);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
					resolve(false);
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}


	updateFunJump = (loadNum, jumpId, jumpPostBody) => {
		////alert('load store update tandem jump ' + JSON.stringify(jumpPostBody));
		////this.emitResults(false, 'InitilizeLoader');

		return new Promise((resolve, reject) => {
			Api.updateFunJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var data = r.data;
					var activeLoadDisplay = data.load;
					//var newActivity = "Fun Jump type update on : " + data.load.loadNum;
					//this.emitResults(newActivity, 'newActivity');
					//this.emitResults(activeLoadDisplay, 'updateLoad');
					this.emitResults(true, 'loadPriceEvent');

					if (jumpPostBody.jumpType)
						this.emitResults(true, 'updateJumpType');

					resolve(true)
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
					resolve(true)
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
					this.emitResults(false, 'loadPriceEvent');
					resolve(true)

				}
				//this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}
	updateFunJumpType = (loadNum, jumpId, jumpPostBody) => {
		this.activeloadNum = loadNum;

		////alert('load store update tandem jump ' + JSON.stringify(jumpPostBody));
		////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateFunJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var data = r.data;
					//var activeLoadDisplay = this.transformLoad(data.load);
					//var newActivity = "Fun Jump type update on : " + data.load.loadNum;
					//this.emitResults(newActivity, 'newActivity');
					//this.emitResults(activeLoadDisplay, 'updateLoad');
					resolve(true)
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Jump could not be cancelled, please contact support.' });
				}
				//this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	getStudentPackageTypes = () => {
		var types = this.studentPackages.map(pkg => pkg.type);
		var packageTypes = [... new Set(types)];
		return packageTypes;
	}
	getDefaultStudentPackageId = (type) => {
		return this.studentPackages.filter(pkg => pkg.type === type)[0]._id;
	}
	getCompletedLoad = (start, end) => {
		return new Promise((resolve, reject) => {
			Api.getCompletedLoad(start, end).then((r) => {
				if (r.status == 200) {
					resolve(r.data);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
					resolve(false);
				}
				// else if (r.status === 500 || r.status === 404) {
				// 	this.emitResults(true, 'warningEvent');
				// 	resolve(false);
				// }
				else {
					this.emitError({ message: 'Load could not be fetched, please contact support.' });
					resolve(false);
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					resolve(false);
				});
		});
	}

	setEdit = () => {
		this.isEdit = true;
	}
	cancelEdit = () => {
		this.isEdit = false;
	}
	loadFunJumpTypes = () => {
		console.log('in load FunJumpTypes');
		return new Promise((resolve, reject) => {
			Api.loadFunJumpTypes().then((r) => {
				if (r.status == 200) {
					this.funJumpTypes = r.data;
					//alert('update plane type');
					//this.emitResults(true, 'updatePlaneActivity');
					//this.emitResults(newActivity, 'newActivity');
					resolve(true);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
					resolve(false);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
					resolve(false);
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					resolve(false);
				});
		});
	}
	getFunJumpTypes = () => {
		return this.funJumpTypes;
	}
	loadTeams = () => {
		return new Promise((resolve, reject) => {
			Api.loadTeams().then((r) => {
				if (r.status === 200) {
					resolve(r.data);
					this.emitResults(r.data, "teamsLoaded")
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					resolve(false);
				});
		});
	}

	cancelCreateJump = (loadnum) => {
		this.activeloadNum = loadnum;
		this.emitResults(loadnum, 'cancelCreateJump');
		this.cancelEdit();
		if (this.loadQueue !== null && this.loadEvent !== '') {
			this.emitResults(this.loadQueue, this.loadEvent);
			this.loadQueue = null;
			this.loadEvent = '';
		}
	}

	updateCompletedTandemMediaFolder = (loadNum, jumpId, jumpPostBody) => {
		////this.emitResults(false, 'InitilizeLoader');
		console.log('delete completed tandem jump');

		return new Promise((resolve, reject) => {
			Api.updateCompletedTandemMediaFolder(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data.load;
					// console.log(r.data)
					/*
					jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					reportsStore.setDropzoneTodayActivity(r.data.summary);
					var newActivity = "tandem Jump updated on load";
					this.emitResults(newActivity, 'newActivity');
					this.emitResults(r.data, 'completeLoadRight');
					this.emitResults(true, 'loadPriceEvent');
					this.emitResults(r.data.load, 'updateCompletedLoads');

					var loading = true;
					this.emitResults(loading, 'loaderActivity');

					updateLoadHistory(load);
					*/

					resolve(true);
				}
				else if (r.status == 401) {
					//this.emitResults(true,'clearSession');
					//this.emitResults(false,	'loadPriceEvent');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'completed Jump could not be Updated, please contact support.' });
				}
				//this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}
	updateCompleteTandemJump = (loadNum, jumpId, jumpPostBody) => {
		////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateCompletedTandem(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data.load;
					// console.log(r.data)
					// jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					// reportsStore.setDropzoneTodayActivity(r.data.summary);
					// var newActivity = "tandem Jump updated on load";
					// this.emitResults(newActivity, 'newActivity');
					// this.emitResults(r.data, 'completeLoadRight');
					// this.emitResults(true, 'loadPriceEvent');
					this.emitResults(r.data.load, 'updateCompletedLoads');
					// updateLoadHistory(load);
					resolve(true);
				}
				else if (r.status == 401) {
					//this.emitResults(true,'clearSession');
					//this.emitResults(false,	'loadPriceEvent');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'completed Jump could not be Updated, please contact support.' });
				}
				//this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}
	updateCompletedCoachJump = (loadNum, jumpId, jumpPostBody) => {
		////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateCompletedCoachJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					var load = r.data.load;
					// jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					// reportsStore.setDropzoneTodayActivity(r.data.summary);
					// console.log("get res updateCompletedCoachJump")
					// var newActivity = "Coach Jump updated on load";
					// this.emitResults(newActivity, 'newActivity');
					// this.emitResults(true, 'loadPriceEvent');
					// this.emitResults(r.data, 'completeLoadRight');
					//this.emitResults(r.data.load, 'updateCompletedLoads');
					// updateLoadHistory(load);
					resolve(true);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				//this.emitResults(false, 'InitilizeLoader');

			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}
	updateCompletedAffJump = (loadNum, jumpId, jumpPostBody) => {
		////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateCompletedAffJump(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					// var load = r.data.load;
					// jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					// reportsStore.setDropzoneTodayActivity(r.data.summary);
					// var newActivity = "Aff Jump updated on load";
					// this.emitResults(newActivity, 'newActivity');
					// this.emitResults(r.data, 'completeLoadRight');
					// this.emitResults(true, 'loadPriceEvent');
					//this.emitResults(r.data.load, 'updateCompletedLoads');
					// updateLoadHistory(load)
					resolve(true)
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				//this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					//this.emitResults(false, 'InitilizeLoader');
					reject(err);
				});
		});
	}

	updateCompletedAffMediaFolder = (loadNum, jumpId, body) => {
		////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateCompletedAffMediaFolder(loadNum, jumpId, body).then((r) => {
				if (r.status == 200) {
					/*
					var load = r.data.load;
					jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					reportsStore.setDropzoneTodayActivity(r.data.summary);
					var newActivity = "Aff Jump updated on load";
					this.emitResults(newActivity, 'newActivity');
					this.emitResults(r.data, 'completeLoadRight');
					this.emitResults(true, 'loadPriceEvent');
					this.emitResults(r.data.load, 'updateCompletedLoads');
					var loading = true;
					this.emitResults(loading, 'loaderActivity');

					updateLoadHistory(load)
					*/

					resolve(true)
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				//this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					//this.emitResults(false, 'InitilizeLoader');
					reject(err);
				});
		});
	}


	loadItems = () => {
		return new Promise((resolve, reject) => {
			Api.loadItems().then((r) => {
				if (r.status == 200) {
					let array = []
					array = array.concat(r.data.tandemRigs)
					array = array.concat(r.data.studentRigs)
					array = array.concat(r.data.sportRigs)
					resolve(array);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'could not load prices.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	completeLoad = (loadNum, date) => {
		return new Promise((resolve, reject) => {
			Api.completeLoad(loadNum, date).then(r => {
				if (r.status === 200) {
					resolve(true);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Load could not be completed, please contact support.' });
				}
			})
				.catch(err => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	updateCompletedCoachMediaFolder = (loadNum, jumpId, jumpPostBody) => {
		////this.emitResults(false, 'InitilizeLoader');
		return new Promise((resolve, reject) => {
			Api.updateCompletedCoachMediaFolder(loadNum, jumpId, jumpPostBody).then((r) => {
				if (r.status == 200) {
					/*
					var load = r.data.load;
					jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					reportsStore.setDropzoneTodayActivity(r.data.summary);
					// console.log("get res updateCompletedCoachJump")
					var newActivity = "Coach Jump updated on load";
					this.emitResults(newActivity, 'newActivity');
					this.emitResults(true, 'loadPriceEvent');
					this.emitResults(r.data, 'completeLoadRight');
					this.emitResults(r.data.load, 'updateCompletedLoads');

					var loading = true;
					this.emitResults(loading, 'loaderActivity');

					updateLoadHistory(load);
					*/
					resolve(true)
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				//this.emitResults(false, 'InitilizeLoader');

			})
				.catch(err => {
					//this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	createJump = (load, jumpDisplay) => {
		// this.activeloadNum = loadNum;

		//console.log('in create Jump');
		//console.log(jumpDisplay);
		if (jumpDisplay.jumpType === "Tandem Jump") {
			load.tandemJumps.push(jumpDisplay);
		}
		else if (jumpDisplay.jumpType === "AFF") {
			load.affJumps.push(jumpDisplay);
		}
		else if (['Belly', 'Wingsuit', 'Tracking', 'Freefly', 'HopNPop'].indexOf(jumpDisplay.jumpType) >= 0) {
			load.funJumps.push(jumpDisplay);
		}
		else {
			this.emitError({ message: 'error with jump data' });
		}
		this.emitResults(load, 'createJump');
	}

	cancelPreviousJump = (loadnum) => {
		this.emitResults(loadnum, 'cancelPreviousJump');
	}
	setNowStatus = (load, timeRemaining) => {
		if (load) {
			load.timeRemaining = timeRemaining
			this.emitResults(load, 'updateLoad_' + load.loadNum);
		}
	}
	processWidgetUpload = (error, result) => {
		console.log('after upload');
		if (error) {
			console.log(error);
		}
		console.log(result.event);
		if (result.event === "queues-end") {
			//jumpersStore.sendMediaEmail(jumperId);
			console.log(result);
		}
		if (!error && result && result.event === "success") {
			console.log('Done! Here is the image info: ', result.info);
			var tags = result.info.tags;
			var jumpType = result.info.tags[1];
			var jumperId = result.info.tags[0];
			if (jumpType === "tandem") {
				var payload = { jumpType: "Tandem", url: result.info.url };
				jumpersStore.addMediaUrl(jumperId, payload);
			}
		}
	}
	getLoadNumByIndx = (indx) => {
		console.log(this.loads);
		var notInAirLds = this.loads.filter(ld => !ld.inAir);
		if (notInAirLds[indx]) {
			return notInAirLds[indx].loadNum;
		}
		return -1;
	}
	createWidget = () => {
		var widget = window.cloudinary.createUploadWidget({
			cloudName: 'dizio',
			uploadPreset: 'ijgsy92r',
			showCompletedButton: true,
			folder: 'test'
		}, this.processWidgetUpload
		);
		this.widget = widget;
	}

	updateWidget = (tag) => {
		this.widget.update({ tags: [tag] });
	}

	openWidget = (jumperId, jumpType) => {
		this.widget.update({ tags: [jumperId, jumpType] });
		this.widget.open();
	}

	getWidget = () => {
		return this.widget;
	}

	emitError = (err) => {
		//console.log(err);
		this.emit('ERROR', err.message);
	}
	getEventPrefix = (func) => {
		return `${this.prefix}${func}`;
	}

	emitResults = (r, func) => {
		//console.log('emitResults');
		if (!r) {
			//console.log(r);
			this.emitError({ message: 'No loads found' });
		}
		this.setMaxListeners(1000);
		//console.log(r);
		this.emit(`${this.prefix}${func}`, r);
	}

	debug = (r) => {
		//console.log(r.data);
	}
	getSchoolWaitlist = () => {
		return this.schoolWaitlist;
	}

	transformLoad(loadBackend) {
		//console.log('in transformBackend');
		var load = { _id: loadBackend._id, closed: loadBackend.closed, plane: loadBackend.plane, loadNum: loadBackend.loadNum, capacity: loadBackend.capacity, totalJumpers: loadBackend.totalJumpers, totalSlots: loadBackend.totalSlots, pilotId: loadBackend.pilotId, activeJumperIds: loadBackend.activeJumperIds };
		//console.log(loadBackend.tandemJumps);
		load.tandemJumps = loadBackend.tandemJumps.map((jump) => jumpersStore.mapTandemForRender(jump));
		load.coachJumps = loadBackend.coachJumps.map((jump) => jumpersStore.mapCoachJumpForRender(jump));
		load.affJumps = loadBackend.affJumps.map(jump => jumpersStore.mapAffForRender(jump));
		load.funJumps = loadBackend.funJumps.map(jump => jumpersStore.mapFunJumpForRender(jump));
		return load;
	}

	initializeTextToSpeech() {
		this.speech = new Speech() // will throw an exception if not browser supported
		if (this.speech.hasBrowserSupport()) { // returns a boolean
			console.log("speech synthesis supported");
			this.speech.init({
				'volume': 1,
				'lang': 'en-US',
				'rate': 1,
				'pitch': 1,
				'voice': 'Google US English',
				'splitSentences': true,
				'listeners': {
					'onvoiceschanged': (voices) => {
						console.log("Event voiceschanged", voices)
					}
				}
			});
		}
		else {
			console.log('speec not supported');
		}
	}
}

const loadsStore = new Loads();
window.loadsStore = loadsStore;
export default loadsStore;
